import AuthModel from './authModel/AuthModel';
import DemoModel from './demoModel/DemoModel';
import ProgressModel from './progressModel/ProgressModel';
import ContactModel from './contactModel/ContactModel';
import { AdvisorModel, ProviderModel } from './infoSetupModel/InfoSetupModel';
import JobPostModel from './jobModel/JobModel';
import AdminModel from './adminModel/AdminModel';
import AdminUserListModel from './adminUserListModel/AdminUserListModel';
import AdvisorFuntionsModel from './advisorModel/AdvisorModel';
import ProviderFuntionalModel from './providerModel/ProviderModel';
import ChatModel from './chatModel/ChatModel';
import BreadCrumbs from './breadCrumbsModel/BreadCrumbsModel';
import TosModel from './tosModel/TosModel';
import HarvestModel from './harvestModel/HarvestModel';

const Models = {
  DemoModel,
  AuthModel,
  ProgressModel,
  ContactModel,
  AdvisorModel,
  JobPostModel,
  ProviderModel,
  AdminModel,
  AdminUserListModel,
  AdvisorFuntionsModel,
  ProviderFuntionalModel,
  ChatModel,
  BreadCrumbs,
  TosModel,
  HarvestModel,
};

export default Models;
